import { openBiExplorerPortal } from 'components/reports/biReportEmbed';
import { useEffect, useRef } from 'react';

export default function AnalyticsProPage() {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const containerId = 'bi-explorer-portal';
			containerRef.current.id = containerId;

			openBiExplorerPortal(containerId).catch(error => {
				console.error('Erro ao carregar BI Explorer:', error);
			});
		}

		return () => {
			if (containerRef.current) {
				containerRef.current.innerHTML = '';
			}
		};
	}, []);

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				width: '100vw',
				height: '100vh',
				overflow: 'hidden',
				backgroundColor: 'white',
				zIndex: 9999,
			}}
		>
			<div
				ref={containerRef}
				style={{
					width: '100%',
					height: '100%',
				}}
				id='bi-explorer-portal'
			/>
		</div>
	);
}
